import { Divider, Input, message, Modal, Table, Tabs, Button, Icon, Select, Row, Col, Tooltip, Typography, Drawer, Timeline } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import { ColumnProps, SorterResult } from 'antd/lib/table';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ORDER_CATEGORY, ORDER_STATUS, EPayStatus, CATEGORY_ORIGINAL } from 'src/constants/Order';
import OrderSearch from 'src/containers/OrderSearch';
import { IPageResult } from 'src/entity/BaseResult';
import { IOrderListColumnData } from 'src/entity/ColumnDataEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { EnumRefundStatus, IOrderInfo, IOrderItem, IOrderListInfo, IOrderRefund, IOrderSearchParam } from 'src/entity/OrderEntity';
import I18N from 'src/services/I18NService';
import OrderService, { EnumInvoiceStatus } from 'src/services/OrderService';
import { UtilDateTime } from 'src/utils/datetime';
import { UNIT_BAG } from 'src/constants/Unit';
import MedicineService from 'src/services/MedicineService';
import { isArray } from 'util';
import { IOrderSearch } from 'src/entity/SearchEntity';
import { MddCurrency, MddDecimal } from '@macrocura/utils';
import OrderPrintService from 'src/services/OrderPrintService';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { MallService, SUPPORT_EXPRESSES } from 'src/services/MallService';
import { ILogistic } from 'src/entity/logistics';
import axios from 'axios';
import PrintExpressDialog from './PrintExpressDialog';
import DrugStoreService from 'src/services/DrugStoreService';
import { IExpressConfig, IPickUpTimeSelect } from 'src/entity/SettingEntity';
import { MallEdiService } from 'src/services/MallEdiService';
import * as moment from 'moment';
import PickUpTime from './components/PickUpTime';
import { getMethodDes } from 'src/redux/actions/userCreator';

const { Paragraph } = Typography;

const { TextArea } = Input;

const { Text } = Typography;

const DEFAULT_PAGE_SIZE = 20;

interface IOrderListPageProps extends RouteComponentProps {
  isAgent: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  drugStores: IDrugStoreInfo[];
  order_id: string;
  setPreOrderSendStatus: (uuid: string) => void;
  fetchDrugStoresIfNeeded: () => void;
  selectOrder: (order: IOrderInfo) => void;
  /**
   * @deprecated
   *
   * @type {ORDER_CATEGORY}
   * @memberof IOrderListPageProps
   */
  category: ORDER_CATEGORY;
}

interface IOrderListPageState {
  loadingTable: boolean;
  columns: Array<ColumnProps<IOrderListColumnData>>;
  dataSource: IOrderListColumnData[];
  /** 待发货订单页 */
  paginationFirst: PaginationProps;
  /** 已发货订单页 */
  paginationSecond: PaginationProps;
  /** 已签收订单页 */
  paginationThird: PaginationProps;
  /** 已完成订单页 */
  paginationFourth: PaginationProps;
  /** 其他订单页 */
  paginationFifth: PaginationProps;
  status: ORDER_STATUS;
  cancelOrderVisible: boolean;
  cancelOrder: IOrderListColumnData | null;
  /** 显示合并打印运单对话框 */
  expressVisible: boolean;
  isMerge: boolean;
  /** 显示编辑运单对话框 */
  editExpressVisible: boolean;
  editExpressError: boolean;
  reason: string;
  /** 导出loading */
  exportLoading: boolean;
  exportBatchDetailLoading: boolean;
  /** 选中的订单keys */
  selectedRowKeys: string[];
  /** 选中的订单是否可以合并运单 */
  canMerge: boolean;

  /** 当前单选订单的ID */
  selectedOrder?: IOrderListColumnData;
  /** 当前选中的快递代号 */
  selectedExpressCompany?: string;
  /** 当前输入的快递单号 */
  selectedExpressNo?: string;
  /** 快递配置 */
  expressConfig: IExpressConfig[];
  /** 是否开通药品订单接口 */
  isOpenOrder: boolean;
  /** /导出明细加载中 */
  exportDetailLoading: boolean;
  /** 退款详情显示 */
  refundVisible: boolean;
  /** 退款详情 */
  refundInfoList: IOrderRefund[];
  pickTime: IPickUpTimeSelect | undefined;
}

type OrderListCache = Pick<
  IOrderListPageState,
  'status' | 'dataSource' | 'paginationFirst' | 'paginationSecond' | 'paginationThird' | 'paginationFourth' | 'paginationFifth'
>;

class OrderListPage extends React.Component<IOrderListPageProps, IOrderListPageState> {
  tablePagination = false;
  child: {
    doSearch: (param: IOrderSearchParam) => void;
    getQueryParam(): () => IOrderSearch | undefined;
    saveCache: (action?: string) => void;
  };
  private static sLastResult?: OrderListCache;
  private shouldCache = false;

  static clearCache() {
    this.sLastResult = undefined;
  }

  constructor(props: IOrderListPageProps) {
    super(props);

    const columns: Array<ColumnProps<IOrderListColumnData>> = [
      {
        title: I18N.get('order_no'),
        key: 'out_trade_no',
        dataIndex: 'out_trade_no',
        width: 200,
      },
      {
        title: '下发时间',
        key: 'distribute_time',
        dataIndex: 'distribute_time',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        width: 180,
      },
      {
        title: '收货信息',
        key: 'receiver',
        dataIndex: 'receiver',
        width: 200,
        sorter: true,
        sortDirections: ['ascend', 'descend'],
      },
      {
        title: '药库',
        key: 'groupName',
        dataIndex: 'groupName',
        width: 150,
        render: (text: any, record: IOrderListColumnData): React.ReactNode => {
          return <Paragraph ellipsis={{ rows: 2, expandable: true }}>{record.groupName}</Paragraph>;
        },
      },
      {
        title: '打印状态',
        key: 'printed',
        dataIndex: 'printed',
        render: (text: any, record: IOrderListColumnData): React.ReactNode => {
          return record.printed ? <span style={{ color: 'green' }}>已打印</span> : <span>未打印</span>;
        },
      },
      {
        title: '关联运单',
        key: 'express',
        dataIndex: 'express',
        render: (text: any, record: IOrderListColumnData, index: number): React.ReactNode => {
          if (record.medicine_take_method === 'SELF') {
            return <span>自提: {record.medicine_take_code}</span>;
          } else {
            const canEdit =
              !this.props.isAgent &&
              (record.orderObj.pay_status === EPayStatus.待发货 || (record.orderObj.pay_status === EPayStatus.已发货 && !record.orderObj.express));
            return (
              <span>
                {record.expressNo || '无运单'}
                {canEdit && (
                  <Icon
                    type="edit"
                    style={{ color: '#43ccd9' }}
                    onClick={() =>
                      this.setState({
                        editExpressVisible: true,
                        editExpressError: false,
                        selectedOrder: record,
                        selectedExpressNo: record.expressNo,
                        selectedExpressCompany: record.expressCompany,
                      })
                    }
                  />
                )}
              </span>
            );
          }
        },
      },
      //   应收金额
      //   {
      //     title: I18N.get('order_receivable_amount'),
      //     key: 'receivableAmount',
      //     dataIndex: 'receivableAmount',
      //   },
      {
        title: '揽件时间',
        key: 'delivery_start_time',
        dataIndex: 'delivery_start_time',
        render: (text: any, record: IOrderListColumnData): React.ReactNode => {
          let label = '';
          const { delivery_start_time, delivery_end_time } = record;
          if (delivery_end_time && delivery_start_time) {
            const date = moment(new Date(delivery_start_time)).format('YYYY-MM-DD');
            const start = moment(new Date(delivery_start_time)).format('HH:mm:ss');
            const end = moment(new Date(delivery_end_time)).format('HH:mm:ss');
            label = `${date} ${start}-${end}`;
          }
          return label;
        },
      },
      // 订单金额
      {
        title: I18N.get('order_payment_amount'),
        key: 'orderPaymentAmount',
        dataIndex: 'orderPaymentAmount',
      },
      // 分润金额（不但与分润， 分润金额为0）
      {
        title: I18N.get('order_received_profit_amount'),
        key: 'userReceivableProfitAmount',
        dataIndex: 'userReceivableProfitAmount',
      },
      {
        title: '加工方式',
        key: 'processing_methods',
        dataIndex: 'processing_methods',
        render: (_: any, record: IOrderListColumnData) => {
          const methods = record.processing_methods;
          if (methods.length > 1) {
            return methods.map((x, index) => (
              <div key={x}>
                处方{index + 1}: {x}
              </div>
            ));
          } else if (methods.length === 1) {
            return record.processing_methods[0];
          } else {
            return '';
          }
        },
      },
      {
        title: '备注',
        key: 'doctor_remarks',
        dataIndex: 'doctor_remarks',
        render: (_: any, record: IOrderListColumnData) => {
          return (
            <Tooltip title={record.doctor_remarks}>
              <Text ellipsis={true} style={{ width: 60 }}>
                {record.doctor_remarks}
              </Text>
            </Tooltip>
          );
        },
      },
      {
        title: I18N.get('common_operation'),
        dataIndex: 'operation',
        key: 'operation',
        // width: 80,
        render: (text: any, record: IOrderListColumnData, index: number): React.ReactNode => {
          return this.props.isAgent ? (
            <span>
              <a onClick={() => this.handleOrderDetail(record)}>{I18N.get('common_detail')}</a>
              <Divider type="vertical" />
              <a onClick={() => this.exportDetailExcel(record)}>导出明细</a>
            </span>
          ) : (
            <span>
              <a onClick={() => this.handleOrderDetail(record)}>{I18N.get('common_detail')}</a>
              <Divider type="vertical" />
              <a onClick={() => this.handlePrintDetail(record, index)}>{record.orderObj.category === CATEGORY_ORIGINAL ? '打印清单' : '打印处方'}</a>
              {/* 自提取消 */}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.线下待支付 && (
                <Divider type="vertical" />
              )}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.线下待支付 && (
                <a onClick={() => this.handleSelfCancel(record)}>{I18N.get('common_cancel')}</a>
              )}
              {/* 自提发货 */}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.待发货 && (
                <Divider type="vertical" />
              )}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.待发货 && (
                <a onClick={() => this.handleSelfSendGood(record)}>{I18N.get('common_sent')}</a>
              )}
              {/* 自提确认收款 */}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.线下待支付 && (
                <Divider type="vertical" />
              )}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method === 'SELF' && record.pay_status === EPayStatus.线下待支付 && (
                <a onClick={() => this.handleSelfConfirmPayment(record)}>{I18N.get('common_confirm_pay')}</a>
              )}

              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && <Divider type="vertical" />}
              {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && (
                <a onClick={() => this.createExpress(record)}>打印运单</a>
              )}
              {/* 是否开启药品订单接口  处方\药品订单需要发送药品清单 2021-5-24 */}
              {this.state.isOpenOrder ? (
                <span>
                  {this.state.status === ORDER_STATUS.STATUS_PAID && !record.send_medicine_order_status && record.medicine_take_method !== 'SELF' && (
                    <Divider type="vertical" />
                  )}
                  {this.state.status === ORDER_STATUS.STATUS_PAID && !record.send_medicine_order_status && record.medicine_take_method !== 'SELF' && (
                    <Button type="link" onClick={() => this.sendMedicineOrder(record)} disabled={!!record.send_loading} loading={!!record.send_loading}>
                      {I18N.get('order_send_medicine')}
                    </Button>
                  )}
                  {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && !!record.send_medicine_order_status && (
                    <Divider type="vertical" />
                  )}
                  {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && !!record.send_medicine_order_status && (
                    <a onClick={() => this.handleSendGood(record)}>发货</a>
                  )}
                </span>
              ) : (
                <span>
                  {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && <Divider type="vertical" />}
                  {this.state.status === ORDER_STATUS.STATUS_PAID && record.medicine_take_method !== 'SELF' && (
                    <a onClick={() => this.handleSendGood(record)}>发货</a>
                  )}
                </span>
              )}
              <Divider type="vertical" />
              <a onClick={() => this.exportDetailExcel(record)}>导出明细</a>
              {record.orderObj.is_exist_refund_order && (
                <span>
                  <Divider type="vertical" />
                  <a onClick={() => this.onRefundVisibleChange(record)}>退款详情</a>
                </span>
              )}
            </span>
          );
        },
      },
    ];

    if (this.props.isAgent) {
      const removeIndex = columns.findIndex((t) => t.key === 'order_invoice_status_desc');
      if (removeIndex > -1) {
        columns.splice(removeIndex, 1);
      }
    }

    this.state = {
      pickTime: undefined,
      loadingTable: false,
      reason: '',
      cancelOrderVisible: false,
      cancelOrder: null,
      columns,
      dataSource: [],
      paginationFirst: {
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        pageSize: DEFAULT_PAGE_SIZE,
        defaultPageSize: DEFAULT_PAGE_SIZE,
      },
      paginationSecond: {
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        pageSize: DEFAULT_PAGE_SIZE,
        defaultPageSize: DEFAULT_PAGE_SIZE,
      },
      paginationThird: {
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        pageSize: DEFAULT_PAGE_SIZE,
        defaultPageSize: DEFAULT_PAGE_SIZE,
      },
      paginationFourth: {
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        pageSize: DEFAULT_PAGE_SIZE,
        defaultPageSize: DEFAULT_PAGE_SIZE,
      },
      paginationFifth: {
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        pageSize: DEFAULT_PAGE_SIZE,
        defaultPageSize: DEFAULT_PAGE_SIZE,
      },
      status: ORDER_STATUS.STATUS_PAID, // 默认是待处理
      expressVisible: false,
      isMerge: false,
      editExpressVisible: false,
      editExpressError: false,
      exportLoading: false,
      exportBatchDetailLoading: false,
      selectedRowKeys: [],
      canMerge: false,

      selectedExpressNo: undefined,
      selectedExpressCompany: undefined,
      expressConfig: [],
      isOpenOrder: false,
      exportDetailLoading: false,
      refundVisible: false,
      refundInfoList: [],
    } as IOrderListPageState;
  }

  get canCancel() {
    return this.state.status === ORDER_STATUS.STATUS_PAID && !this.props.isAgent;
  }

  async componentDidMount() {
    await this.props.fetchDrugStoresIfNeeded();
    if (OrderListPage.sLastResult) {
      this.setState(OrderListPage.sLastResult);
    } else {
      this.child.saveCache('clear');
      this.child.doSearch({
        limit: DEFAULT_PAGE_SIZE,
        offset: 0,
      });
    }
  }

  async UNSAFE_componentWillMount() {
    // 境内配药中心获取快递配置
    this.getExpressConfig();
    this.getOpenOrderConfig();
  }

  UNSAFE_componentWillReceiveProps(nextProps: IOrderListPageProps) {
    if (!!nextProps.order_id) {
      this.updateDataSendStatus(nextProps.order_id);
    }
  }

  componentWillUnmount() {
    if (this.shouldCache) {
      OrderListPage.sLastResult = {
        status: this.state.status,
        dataSource: this.state.dataSource,
        paginationFirst: this.state.paginationFirst,
        paginationSecond: this.state.paginationSecond,
        paginationThird: this.state.paginationThird,
        paginationFourth: this.state.paginationFourth,
        paginationFifth: this.state.paginationFifth,
      };
      this.child.saveCache();
    } else {
      OrderListPage.sLastResult = undefined;
      this.child.saveCache('clear');
    }

    this.setState = () => {
      return;
    };
  }

  onRefOrderSearch = (ref: any) => {
    this.child = ref;
  };

  handleTableOnChange = (
    pagination: PaginationProps,
    filters: Partial<Record<keyof IOrderListColumnData, string[]>>,
    sorter: SorterResult<IOrderListColumnData>
  ) => {
    this.tablePagination = true;
    const pager: PaginationProps = this.getCurrentPage();
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setCurrentPage(pager);

    let ordering: string | undefined;
    if (sorter.field === 'receiver') {
      const fields = ['receiver_name', 'receiver_mobile', 'receiver_structure_address', 'receiver_address'];
      if (sorter.order === 'ascend') {
        ordering = fields.join(',');
      } else if (sorter.order === 'descend') {
        ordering = fields.map((f) => '-' + f).join(',');
      }
    } else if (sorter.field === 'distribute_time') {
      if (sorter.order === 'ascend') {
        ordering = 'distribute_time';
      } else if (sorter.order === 'descend') {
        ordering = '-distribute_time';
      }
    }

    if (!!pager.current && Number(pager.current) > 0) {
      this.child.doSearch({
        ordering,
        limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
        offset: (pager.current - 1) * Number(pagination.pageSize),
      });
    }
  };

  handleOrderDetail = async (record: IOrderListColumnData) => {
    if (!record) {
      return;
    }

    this.shouldCache = true;

    const orderObj = await OrderService.getOrderInfo(record.orderObj.id);
    orderObj.express = record.orderObj.express;
    const { match } = this.props;
    this.props.selectOrder(orderObj);
    this.props.history.push(`${match.path}/${record.key}`);
  };

  /** 自提订单取消 */
  handleSelfCancel = async (record: IOrderListColumnData) => {
    const self = this;
    Modal.confirm({
      title: '该自提订单尚未支付，确认取消订单？',
      content: '',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        OrderService.selfCancelOrder(record.orderObj.out_trade_no).then((success) => {
          if (!!success) {
            // 刷新列表
            const pagination: PaginationProps = self.getCurrentPage();
            if (!!pagination.current && Number(pagination.current) > 0) {
              self.child.doSearch({
                limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
                offset: (pagination.current - 1) * Number(pagination.pageSize),
              });
            }
          }
        });
      },
      onCancel() {},
    });
  };

  /** 自提确定收款 */
  handleSelfConfirmPayment = async (record: IOrderListColumnData) => {
    const self = this;
    Modal.confirm({
      title: '该自提订单尚未支付，确认患者已在线下完成付款？',
      content: '',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        OrderService.confirmPaymentOrder(record.orderObj.out_trade_no).then((success) => {
          if (!!success) {
            // 刷新列表
            const pagination: PaginationProps = self.getCurrentPage();
            if (!!pagination.current && Number(pagination.current) > 0) {
              self.child.doSearch({
                limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
                offset: (pagination.current - 1) * Number(pagination.pageSize),
              });
            }
          }
        });
      },
      onCancel() {},
    });
  };

  /** 自提发货 */
  handleSelfSendGood = async (record: IOrderListColumnData) => {
    const self = this;
    Modal.confirm({
      title: '是否确认发货',
      content: '',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        OrderService.finishOrder(record.orderObj.out_trade_no).then((success) => {
          if (!!success) {
            // 刷新列表
            const pagination: PaginationProps = self.getCurrentPage();
            if (!!pagination.current && Number(pagination.current) > 0) {
              self.child.doSearch({
                limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
                offset: (pagination.current - 1) * Number(pagination.pageSize),
              });
            }
          }
        });
      },
      onCancel() {},
    });
  };

  /**
   * 导出明细excel
   * @param record
   * @returns
   */
  exportDetailExcel = async (record: IOrderListColumnData) => {
    const { exportDetailLoading } = this.state;
    if (!record || exportDetailLoading) {
      return;
    }
    this.setState({ exportDetailLoading: true });
    const isSucceeded = await OrderService.exportOrderExcel(record.key);
    this.setState({ exportDetailLoading: false });
    if (!isSucceeded) {
      message.error(':(明细导出失败了！');
    }
  };

  handlePrintDetail = async (record: IOrderListColumnData, index: number) => {
    const order = await OrderService.getOrderInfo(record.orderObj.id);
    order.express = record.orderObj.express;
    const success = await OrderPrintService.printOrderList(order);
    if (!success) {
      message.error(':(打印失败了！');
      return;
    }

    const { dataSource } = this.state;
    dataSource[index].printed = true;
    this.setState({ dataSource });

    // 更新打印时间
    OrderService.updatePrintDate(record.orderObj.id);
  };

  handleSendGood = (record: IOrderListColumnData) => {
    const title = record.expressNo ? `运单号${record.expressNo}, 是否确认发货?` : '订单尚未关联运单号，是否确认发货？';
    const self = this;
    Modal.confirm({
      title,
      content: '发货后将不能更改运单',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        OrderService.finishOrder(record.orderObj.out_trade_no).then((success) => {
          if (!!success) {
            // 刷新列表
            const pagination: PaginationProps = self.getCurrentPage();
            if (!!pagination.current && Number(pagination.current) > 0) {
              self.child.doSearch({
                limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
                offset: (pagination.current - 1) * Number(pagination.pageSize),
              });
            }
          }
        });
      },
      onCancel() {},
    });
  };

  private checkPickTime():
    | {
        delivery_start_time: string;
        delivery_end_time: string;
      }
    | undefined {
    const { pickTime } = this.state;
    if (!pickTime) {
      message.warning('请选择上门取件时间');
      return undefined;
    } else {
      let start = '';
      let end = '';
      if (pickTime.isActual) {
        const date = new Date();
        const startTime = moment(date).format('HH:mm:ss');
        const endTime = moment(date).add('hours', 1).format('HH:mm:ss');
        start = new Date(`${pickTime.date} ${startTime}`).toISOString();
        end = new Date(`${pickTime.date} ${endTime}`).toISOString();
      } else {
        start = new Date(`${pickTime.date} ${pickTime.time.start}:00:00`).toISOString();
        end = new Date(`${pickTime.date} ${pickTime.time.end}:00:00`).toISOString();
      }
      return {
        delivery_start_time: start,
        delivery_end_time: end,
      };
    }
  }

  /**
   * @deprecated 暂未使用
   */
  showModal = (record: IOrderListColumnData) => {
    if (!record) {
      return;
    }
    if (record.orderObj.invoice_issue_status_wrapper === EnumInvoiceStatus.已开具) {
      message.warning(I18N.get('err_cannot_cancel_order', false));
      return;
    }
    this.setState({
      cancelOrderVisible: true,
      cancelOrder: record,
    });
  };

  handleSearch = async (status: ORDER_STATUS, result: IPageResult<IOrderListInfo[]>): Promise<void> => {
    if (this.state.status !== status) {
      return;
    }

    this.setState({
      loadingTable: true,
    });
    let dataList: IOrderListColumnData[] = [];
    const pagination = this.getCurrentPage();
    if (!!result && isArray(result.results)) {
      pagination.total = result.count;
      if (!this.tablePagination) {
        pagination.current = 1;
      }
      dataList = await this.tableDataTransfer(result.results, pagination);
    }

    this.setCurrentPage(pagination, { dataSource: dataList, loadingTable: false });

    this.tablePagination = false;
  };

  /**
   * 将 IOrderInfo[] 转化为 IOrderListColumnData[]
   */
  private async tableDataTransfer(sourceList: IOrderListInfo[], pagination?: PaginationProps): Promise<IOrderListColumnData[]> {
    const result: IOrderListColumnData[] = [];
    for (let i = 0, len = sourceList.length; i < len; i++) {
      const obj = sourceList[i] as IOrderListInfo;
      const currencySymbol = MddCurrency.getCurrencySymbol(obj.currency || 'CNY');
      // 根据订单是否参与分账，显示应收金额不同字段
      const { user_profit_amount: profitAmount } = obj;
      const orderPaymentAmount = obj.order_payment_amount;
      let userReceivableProfitAmount = (0).toFixed(2);
      if (!!profitAmount && !!profitAmount.user_receivable_profit_amount) {
        userReceivableProfitAmount = MddDecimal.decimalCeil(Number(profitAmount.user_receivable_profit_amount) / 100).toFixed(2);
      }
      //   let isSubAccount = false;
      //   do {
      //     if (!profitAmount) {
      //       break;
      //     }
      //     if (obj.payment_type === PAYMENT_POSTPAID || !obj.platform_name) {
      //       // 老流程 or 记账模式
      //       break;
      //     }
      //     if (typeof profitAmount.user_received_profit_amount !== 'number' && typeof profitAmount.user_receivable_profit_amount !== 'number') {
      //       // 不参与分账
      //       break;
      //     }
      //     isSubAccount = true;
      //   } while (false);
      // 应收金额
      //   let receivableAmount = obj.transfer_amount_after_tax;
      //   if (isSubAccount && profitAmount) {
      //     // 参与分账则取user_receivable_profit_amount字段(后台单位分)
      //     if (typeof profitAmount.user_receivable_profit_amount === 'number') {
      //       receivableAmount = MddDecimal.decimalCeil(profitAmount.user_receivable_profit_amount / 100).toFixed(2);
      //     } else {
      //       receivableAmount = (0).toFixed(2);
      //     }
      //   }
      const addressName = await this.fetchStructureAddress(obj.receiver_structure_address);
      let addressList = addressName.split(',');
      if (addressList[0] === '北京市' || addressList[0] === '上海市' || addressList[0] === '重庆市' || addressList[0] === '天津市') {
        addressList = addressList.slice(1);
      }
      result.push({
        key: obj.id,
        distribute_time: obj.distribute_time ? UtilDateTime.getDateTimeFormat(obj.distribute_time) : '',
        out_trade_no: obj.out_trade_no,
        groupName: obj.medicine_groups,
        receiver: [obj.receiver_name, obj.receiver_mobile, addressList.join('') + obj.receiver_address].join(' '),
        // receivableAmount: `${currencySymbol}${receivableAmount}`,
        orderPaymentAmount: `${currencySymbol}${orderPaymentAmount}`, // 订单金额显示
        order_payment_amount: Number(orderPaymentAmount), // 订单金额
        userReceivableProfitAmount: `${currencySymbol}${userReceivableProfitAmount}`, // 分润金额
        orderObj: obj,
        printed: !!obj.first_print_prescription_time,
        expressNo: obj.express?.express_no,
        expressCompany: obj.express?.express_company,
        institution_name: obj.institution_name,
        send_medicine_order_status: !!obj.send_medicine_order_status,
        send_loading: false,
        delivery_end_time: obj.delivery_end_time || '',
        delivery_start_time: obj.delivery_start_time || '',
        doctor_remarks: obj.doctor_remarks,
        medicine_take_method: obj.medicine_take_method,
        medicine_take_code: obj.medicine_take_code,
        pay_status: obj.pay_status,
        processing_methods: obj.processing_methods.map((x) => {
          return getMethodDes(x);
        }),
      });
    }
    return result;
  }

  private async fetchStructureAddress(address: number | string): Promise<string> {
    const area = Number(address);
    if (area > 0) {
      const location = await OrderService.getLocationArea(area);
      if (location) {
        return location.division_names;
      }
    }

    return '';
  }

  /**
   * 合并打印运单
   */
  mergeExpress = () => {
    if (this.state.canMerge) {
      this.setState({ expressVisible: true, isMerge: true });
    } else {
      Modal.info({
        title: '提示',
        content: (
          <div>
            <p>请至少选择2个收货信息相同的订单！</p>
          </div>
        ),
        onOk() {},
      });
    }
  };

  createExpress = (record: IOrderListColumnData) => {
    this.setState({
      expressVisible: true,
      isMerge: false,
      selectedOrder: record,
    });
  };

  sendMedicineOrder = async (record: IOrderListColumnData) => {
    const { dataSource } = this.state;

    const index = dataSource.findIndex((i) => i.key === record.key);
    if (index > -1) {
      if (dataSource[index].send_loading) {
        return;
      }

      dataSource[index].send_loading = true;
      this.setState({
        dataSource,
      });
    }
    if (!this.state.isOpenOrder) {
      return;
    }
    const res = await MallEdiService.sendOrderMedicine(record.key);
    const sendSuccessRes = res.filter((i) => i.status === 'SUCCESS');
    dataSource[index].send_loading = false;
    this.setState({
      dataSource,
    });
    // 如果返回结果长度不为0 && 都成功了 表示发送成功。则更新列表该数据
    if (sendSuccessRes.length === res.length) {
      message.success(I18N.get('order_send_medicine_success'));
      this.updateDataSendStatus(record.key);
    } else {
      const sendFailedRes = res.find((i) => i.status === 'FAILED');
      if (sendFailedRes) {
        message.error(I18N.get('order_send_medicine_failed'));
      } else {
        message.warn(I18N.get('order_send_medicine_sending'));
      }
    }
  };

  /**
   * 更新列表某订单数据send_medicine_order_status 状态
   */
  updateDataSendStatus(uuid: string) {
    const { dataSource } = this.state;
    const index = dataSource.findIndex((i) => i.key === uuid);
    if (index > -1) {
      const timer1 = setTimeout(() => {
        dataSource[index].send_medicine_order_status = true;
        this.setState({
          dataSource,
        });
        message.success(
          I18N.get('common_orders') + `: ${dataSource[index].out_trade_no}` + I18N.get('common_drug_list') + I18N.get('order_send_medicine_success')
        );
        clearTimeout(timer1);
        this.props.setPreOrderSendStatus('');
      }, 1000);
    }
  }

  /**
   * 订单导出excel, 由后端导出
   */
  orderExport = async (isDetail: boolean = false) => {
    const queryParam = this.child.getQueryParam();
    const pagination = this.getCurrentPage();
    let total = pagination.total;
    if (!total || !queryParam) {
      return;
    }

    // 最多支持导出2000条, 若超出按2000条按2000条
    const limitCount = 2000;
    if (total > limitCount) {
      message.warn(I18N.get('order_export_warn'));
      total = limitCount;
    }
    const exportParam: IOrderSearch = {
      ...queryParam,
      limit: total,
      offset: 0,
      // invoice_issue_status_wrapper,
    };
    if (isDetail) {
      this.setState({ exportBatchDetailLoading: true });
    } else {
      this.setState({ exportLoading: true });
    }

    const flag = await OrderService.exportOrder2Excel(exportParam, isDetail);
    flag ? message.success(I18N.get('common_export_success')) : message.error(I18N.get('err_export_failure'));
    // try {
    // const result: IPageResult<IOrderListInfo[]> = await OrderService.getOrders(exportParam);
    //   if (!!result && isArray(result.results)) {
    //     const dataList = await this.tableDataTransfer(result.results);
    //     FileService.orderExport(this.props.isAgent, this.state.status, dataList);
    //   }
    // } catch (error) {
    //   if (!!error.response) {
    //     message.error(JSON.stringify(error.response.data));
    //   } else {
    //     message.error(I18N.get('err_export_failure'));
    //   }
    //   console.error(error);
    // }
    if (isDetail) {
      this.setState({ exportBatchDetailLoading: false });
    } else {
      this.setState({ exportLoading: false });
    }
  };

  /**
   * 订单内容拼接
   *
   * @memberof OrderListPage
   */
  getOrderItemDesc = (items: IOrderItem[] = []): string => {
    const descList: string[] = [];
    const gram = I18N.get('common_unit_gram');
    for (const item of items) {
      const n = item.short_name;
      const q = item.quantity;
      const u = MedicineService.getEnumUnitKey(item.retail_unit);
      // const s = item.equivalent;
      // descList.push(`${n} ${s}${I18N.get('common_unit_gram')}\u00D7${q}${I18N.get(u)}`);
      if (item.retail_unit === UNIT_BAG) {
        const s = item.equivalent;
        descList.push(`${n}(${s}${gram})\u00D7${q}${I18N.get(u)}`);
      } else {
        descList.push(`${n} ${q}${I18N.get(u)}`);
      }
    }
    return descList.join(', ');
  };

  changeTabs = (key: string) => {
    const status = Number(key) as ORDER_STATUS;
    const page = this.getCurrentPage();

    this.setState(
      {
        status,
        dataSource: [],
        selectedRowKeys: [],
      },
      () => {
        this.child.doSearch({
          limit: page.pageSize || DEFAULT_PAGE_SIZE,
          offset: 0,
        });
      }
    );
  };

  reasonChange = (e: any) => {
    this.setState({
      reason: e.target.value,
    });
  };

  async handleCancelOrder(ok: boolean) {
    if (ok && !this.state.reason) {
      return;
    }

    if (ok && !!this.state.cancelOrder) {
      // 取消订单
      try {
        const orderObj = this.state.cancelOrder.orderObj;
        const amount = Number(orderObj.order_payment_amount);
        await OrderService.cancelOrder(orderObj.out_trade_no, amount, this.state.reason);

        // 刷新列表
        const pagination: PaginationProps = this.getCurrentPage();
        if (!!pagination.current && Number(pagination.current) > 0) {
          this.child.doSearch({
            limit: pagination.pageSize || DEFAULT_PAGE_SIZE,
            offset: (pagination.current - 1) * Number(pagination.pageSize),
          });
        }
      } catch (error) {
        if (!!error.response) {
          message.error(JSON.stringify(error.response.data));
        } else {
          message.error(I18N.get('err_save_failure'));
        }
      }
    }

    this.setState({ cancelOrderVisible: false, cancelOrder: null });
  }

  handleMergeExpress = async () => {
    const deliveryDate = this.checkPickTime();
    if (!deliveryDate) {
      return;
    }

    const { userInfo, isAgent } = this.props;
    if (isAgent || !userInfo) {
      return;
    }

    const drugStoreInfo = userInfo as IDrugStoreInfo;

    const orderNumbers: Array<{ order_no: string; name: string }> = [];
    let selectedOrder: IOrderListColumnData | undefined;
    const selected = new Set(this.state.selectedRowKeys);
    this.state.dataSource.forEach((item) => {
      if (selected.has(item.key)) {
        selectedOrder = item;
        if (item.orderObj.medicine_take_method !== 'SELF') {
          orderNumbers.push({ order_no: item.orderObj.id, name: '药品' });
        }
      }
    });

    if (!selectedOrder) {
      return;
    }

    if (!drugStoreInfo.delivery_location) {
      return;
    }

    const order = selectedOrder.orderObj;
    const receiverRegion = await this.fetchStructureAddress(order.receiver_structure_address);
    const senderRegion = await this.fetchStructureAddress(drugStoreInfo.delivery_location);

    const express = await MallService.createExpress({
      express_company: drugStoreInfo.express_company || '',
      express_bill_template: typeof drugStoreInfo.express_bill_template !== 'undefined' ? drugStoreInfo.express_bill_template : 100,
      is_auto_created: true,
      sender_name: drugStoreInfo.delivery_name || undefined,
      sender_address: drugStoreInfo.delivery_address || undefined,
      sender_mobile: drugStoreInfo.delivery_mobile || undefined,
      sender_region: senderRegion,
      receiver: order.doctor_uuid,
      receiver_name: order.receiver_name || undefined,
      receiver_region: receiverRegion,
      receiver_mobile: order.receiver_mobile,
      receiver_address: order.receiver_address,
      goods: orderNumbers,
      delivery_start_time: deliveryDate.delivery_start_time,
      delivery_end_time: deliveryDate.delivery_end_time,
    });

    if (express) {
      this.setState({ expressVisible: false });
      const { dataSource } = this.state;
      for (const row of dataSource) {
        if (selected.has(row.key)) {
          row.orderObj.express = express;
          row.expressCompany = express.express_company;
          row.expressNo = express.express_no;
          row.delivery_start_time = express.delivery_start_time;
          row.delivery_end_time = express.delivery_end_time;
        }
      }
      this.setState({ dataSource });

      this.printSheet(express);
    }
  };

  private async printSheet(express?: ILogistic) {
    if (express && express.sheet_template) {
      const res = await axios.get(express.sheet_template, { responseType: 'arraybuffer' });
      if (res && res.data) {
        if (express.express_company === 'SF') {
          const data = res.data as unknown as BlobPart;
          const blob = new Blob([data], {
            type: 'application/pdf',
          });
          OrderPrintService.printExpressPageSF(blob);
        } else {
          const buff = res.data as ArrayBuffer;
          const str = new TextDecoder('utf-8').decode(buff);
          OrderPrintService.printExpressPage(str);
        }

        for (const goods of express.goods) {
          OrderService.updatePrintLogisticsDate(goods.order_no);
        }
      }
    }
  }

  async handleEditExpress() {
    const { userInfo, isAgent } = this.props;
    if (isAgent || !userInfo) {
      this.setState({
        editExpressVisible: false,
      });
      return;
    }

    if (!this.state.selectedExpressCompany || !this.state.selectedExpressNo) {
      this.setState({
        editExpressError: true,
      });
      return;
    } else {
      this.setState({
        editExpressVisible: false,
      });
    }

    const drugStoreInfo = userInfo as IDrugStoreInfo;

    const { selectedExpressCompany, selectedExpressNo, selectedOrder } = this.state;
    if (selectedOrder && selectedExpressCompany && selectedExpressNo) {
      const order = selectedOrder.orderObj;
      const express = await MallService.createExpress({
        express_company: selectedExpressCompany,
        express_no: selectedExpressNo,
        sender_mobile: drugStoreInfo.delivery_mobile || undefined,
        receiver: order.doctor_uuid,
        receiver_mobile: order.receiver_mobile || undefined,
        is_auto_created: false,
        goods: [
          {
            order_no: selectedOrder.orderObj.id,
            name: '药品',
          },
        ],
      });

      if (express) {
        const { dataSource } = this.state;
        for (const row of dataSource) {
          if (row.orderObj.id === selectedOrder.orderObj.id) {
            row.orderObj.express = express;
            row.expressCompany = express.express_company;
            row.expressNo = express.express_no;
            break;
          }
        }
        this.setState({ dataSource });
      }
    }
  }

  /**
   * Table 选中项发生变化时的回调
   *
   * @memberof CommonTable
   */
  onSelectChange = (selectedRowKeys: string[] | number[], selectedRows: IOrderListColumnData[]) => {
    const sameAddress = selectedRows.length > 1 && selectedRows.every((item, index, array) => item.receiver === array[0].receiver);
    const keys = selectedRows.map((item) => item.key);
    this.setState({ selectedRowKeys: keys, canMerge: sameAddress });
  };

  /**
   * 获取快递配置信息
   */
  async getExpressConfig() {
    try {
      const res = await DrugStoreService.fetchExpressConfig();
      if (Array.isArray(res) && res.length > 0) {
        this.setState({ expressConfig: res });
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 获取配置是否开通药品订单接口
   */
  async getOpenOrderConfig() {
    try {
      const config = await MallEdiService.getSendOrderMedicineConfig();
      if (!!config) {
        this.setState({
          isOpenOrder: config.is_enabled,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  /** 退款详情显示变更 */
  onRefundVisibleChange = async (record?: IOrderListColumnData) => {
    let refundInfoList: IOrderRefund[] = [];
    if (!!record && !!record.out_trade_no) {
      refundInfoList = await OrderService.fetchOrderRefundInfoList(record.out_trade_no);
    }
    this.setState({
      refundVisible: !!record,
      selectedOrder: record,
      refundInfoList,
    });
  };

  onPickUpTimeChange = (value: IPickUpTimeSelect | undefined) => {
    this.setState({
      pickTime: value,
    });
  };

  render() {
    const operations = (
      <div>
        {!this.props.isAgent && this.state.status === ORDER_STATUS.STATUS_PAID && (
          <Button onClick={this.mergeExpress} style={{ marginRight: 5 }}>
            {'合并打印运单'}
          </Button>
        )}
        {/* 导出 */}
        <Button onClick={() => this.orderExport()} loading={this.state.exportLoading} style={{ marginRight: 5 }}>
          {'导出订单'}
        </Button>
        {/* 导出明细 */}
        <Button onClick={() => this.orderExport(true)} loading={this.state.exportBatchDetailLoading}>
          {'导出明细'}
        </Button>
      </div>
    );

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const orderNumbers: string[] = [];
    if (this.state.expressVisible) {
      const selected = new Set(this.state.selectedRowKeys);
      this.state.dataSource.forEach((item) => {
        if (selected.has(item.key) && item.orderObj.express) {
          orderNumbers.push(item.out_trade_no);
        }
      });
    }

    const { selectedOrder, status, expressConfig } = this.state;
    const { userInfo } = this.props;
    const drugStoreInfo = userInfo as IDrugStoreInfo;

    const page = this.getCurrentPage();
    const pageSize = page.pageSize || 20;
    const matchedExpress = expressConfig.find((item) => item.code === (drugStoreInfo && drugStoreInfo.express_company));
    const formatExpressPayer = (): string => {
      if (!drugStoreInfo) {
        return '';
      }

      const payers: { [key: string]: string } = { macrocura: '脉景', seller: '配药中心' };
      const methods: { [key: string]: string } = { PAYG: '现付', MON: '月结' };
      const payer = payers[drugStoreInfo.express_payer] || '';
      const method = methods[drugStoreInfo.express_payment_type] || '';
      return [payer, method].join('-');
    };
    return (
      <div>
        <OrderSearch onRef={this.onRefOrderSearch} status={status} pageSize={pageSize} cbSearch={this.handleSearch} />
        <Tabs
          defaultActiveKey={String(ORDER_STATUS.STATUS_PAID)}
          activeKey={String(status)}
          onChange={this.changeTabs}
          tabBarExtraContent={operations}
          style={{ marginTop: 15 }}
        >
          <Tabs.TabPane tab={I18N.get('common_status_pending')} key={String(ORDER_STATUS.STATUS_PAID)}>
            <Table
              rowSelection={rowSelection}
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationFirst}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={I18N.get('common_status_sent')} key={String(ORDER_STATUS.STATUS_SENT)}>
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationSecond}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={I18N.get('common_status_signed')} key={String(ORDER_STATUS.STATUS_SIGNED)}>
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationThird}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={I18N.get('common_status_finish')} key={String(ORDER_STATUS.STATUS_FINISHED)}>
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationFourth}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab={I18N.get('common_status_other')} key={String(ORDER_STATUS.STATUS_OTHER)}>
            <Table
              loading={this.state.loadingTable}
              columns={this.state.columns}
              pagination={this.state.paginationFifth}
              dataSource={this.state.dataSource}
              onChange={this.handleTableOnChange}
            />
          </Tabs.TabPane>
        </Tabs>

        <Modal
          title={`取消订单`}
          visible={this.state.cancelOrderVisible}
          onOk={() => this.handleCancelOrder(true)}
          onCancel={() => this.handleCancelOrder(false)}
          okText="确认"
          cancelText="取消"
        >
          <p>
            订单号：<span>{this.state.cancelOrder ? this.state.cancelOrder.out_trade_no : ''}</span>
          </p>
          <p>
            <span style={{ color: 'red' }}>*</span>取消原因
            <TextArea value={this.state.reason} onChange={this.reasonChange} rows={4} />
          </p>
          <div />
        </Modal>

        {this.state.isMerge ? (
          <Modal
            title={`合并打印运单`}
            visible={this.state.expressVisible}
            onCancel={() => this.setState({ expressVisible: false })}
            footer={[
              <Button key="print" type="primary" onClick={this.handleMergeExpress}>
                确定并打印运单
              </Button>,
              <Button key="cancel" onClick={() => this.setState({ expressVisible: false })}>
                取消
              </Button>,
            ]}
          >
            <PickUpTime onPick={this.onPickUpTimeChange} />
            <p>
              物流公司：<span>{(matchedExpress && matchedExpress.name) || ''}</span>
            </p>
            <p>
              运费支付方：<span>{formatExpressPayer()}</span>
            </p>
            <p style={{ color: '#888' }}>
              {orderNumbers.length > 0 ? `订单${orderNumbers.join(',')}已有运单，再次打印运单会生成新的运单号。` : ''}
              合并打印订单将会为所选订单生成同一个运单，是否确认并打印运单？（注：每个订单每天最多只能下5个运单）
            </p>
          </Modal>
        ) : (
          this.state.expressVisible && (
            <PrintExpressDialog
              onCancel={() => this.setState({ expressVisible: false })}
              onOk={() => this.setState({ expressVisible: false })}
              onExpressChange={this.handleExpressChange}
              drugStoreInfo={drugStoreInfo}
              order={selectedOrder?.orderObj}
            />
          )
        )}

        <Modal
          title={'设置运单'}
          visible={this.state.editExpressVisible}
          onOk={() => this.handleEditExpress()}
          onCancel={() => this.setState({ editExpressVisible: false })}
          okText="确定"
          cancelText="取消"
        >
          <Row gutter={24} style={{ marginBottom: 8 }}>
            <Col span={6}>物流公司：</Col>
            <Col span={14}>
              <Select
                placeholder={I18N.get('common_choose')}
                style={{ width: '100%' }}
                value={this.state.selectedExpressCompany}
                onChange={(value: any) => this.setState({ selectedExpressCompany: value })}
              >
                {this.getExpressOption()}
              </Select>
            </Col>
          </Row>
          <Row gutter={24} style={{ marginBottom: 16 }}>
            <Col span={6}>运单号：</Col>
            <Col span={14}>
              <Input placeholder={'请输入运单号'} value={this.state.selectedExpressNo} onChange={(e) => this.setState({ selectedExpressNo: e.target.value })} />
            </Col>
          </Row>
          {this.state.editExpressError && <p style={{ color: 'rgb(245, 34, 45)' }}>注：物流公司和运单号不能为空！</p>}
          <div />
        </Modal>

        {this.state.refundVisible && (
          <Drawer
            title="退款详情"
            placement="right"
            closable={true}
            onClose={() => this.onRefundVisibleChange()}
            visible={this.state.refundVisible}
            width={480}
            maskClosable={false}
          >
            <Timeline>
              {(this.state.refundInfoList || []).map((refundInfo) => {
                return (
                  <Timeline.Item key={refundInfo.business_out_trade_no}>
                    <div className="refund-info">
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          申请退款时间：
                        </Col>
                        <Col span={16}>{moment(refundInfo.apply_time).format('YYYY-MM-DD HH:mm:ss')}</Col>
                      </Row>
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          退款单号：
                        </Col>
                        <Col span={16}>{refundInfo.out_trade_no}</Col>
                      </Row>
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          退款方式：
                        </Col>
                        <Col span={16}>{refundInfo.type === 'FULL_REFUND' ? '全额退款' : '部分退款'}</Col>
                      </Row>
                      {(refundInfo.goods || []).length > 0 && (
                        <Row className="refund-item">
                          <Col className="refund-item-left" span={8}>
                            退货药品：
                          </Col>
                          <Col span={16}>
                            {(refundInfo.goods || []).map((good, index) => {
                              return (
                                <div key={good.uuid}>
                                  {index + 1}.{good.name}
                                  {good.type === 'TCM' ? `（${good.equivalent}${good.equivalent_unit}）` : ''}退{good.quantity}
                                  {good.purchase_unit}
                                </div>
                              );
                            })}
                          </Col>
                        </Row>
                      )}
                      {refundInfo.shipping_cost !== undefined && refundInfo.shipping_cost !== null && (
                        <Row className="refund-item">
                          <Col className="refund-item-left" span={8}>
                            退运费：
                          </Col>
                          <Col span={16}>￥{refundInfo.shipping_cost}</Col>
                        </Row>
                      )}
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          退款金额：
                        </Col>
                        <Col span={16}>￥{refundInfo.amount}</Col>
                      </Row>
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          退款原因：
                        </Col>
                        <Col span={16}>{refundInfo.reason}</Col>
                      </Row>
                      <Row className="refund-item">
                        <Col className="refund-item-left" span={8}>
                          退款状态：
                        </Col>
                        <Col span={16}>
                          {refundInfo.status === EnumRefundStatus.退款驳回 ? (
                            <span style={{ color: '#FF4D4F' }}>{EnumRefundStatus[refundInfo.status]}</span>
                          ) : (
                            <span>{EnumRefundStatus[refundInfo.status]}</span>
                          )}
                        </Col>
                      </Row>
                      {!!refundInfo.reject_reason && (
                        <Row className="refund-item">
                          <Col className="refund-item-left" span={8}>
                            驳回原因：
                          </Col>
                          <Col span={16}>{refundInfo.reject_reason}</Col>
                        </Row>
                      )}
                    </div>
                  </Timeline.Item>
                );
              })}
            </Timeline>
          </Drawer>
        )}
      </div>
    );
  }

  getExpressOption(): JSX.Element[] {
    const options: JSX.Element[] = [];
    for (const option of SUPPORT_EXPRESSES) {
      options.push(
        <Select.Option key={option.value} value={option.value}>
          {option.name}
        </Select.Option>
      );
    }
    return options;
  }

  /**
   * @param orderId, 订单主键
   */
  handleExpressChange = (orderId: string, express: ILogistic) => {
    const { dataSource } = this.state;
    for (const row of dataSource) {
      if (row.orderObj.id === orderId) {
        row.orderObj.express = express;
        row.expressCompany = express.express_company;
        row.expressNo = express.express_no;
        row.delivery_start_time = express.delivery_start_time;
        row.delivery_end_time = express.delivery_end_time;
        break;
      }
    }
    this.setState({ dataSource });
  };

  private getCurrentPage(): PaginationProps {
    let pager: PaginationProps;
    if (this.state.status === ORDER_STATUS.STATUS_PAID) {
      pager = { ...this.state.paginationFirst };
    } else if (this.state.status === ORDER_STATUS.STATUS_SENT) {
      pager = { ...this.state.paginationSecond };
    } else if (this.state.status === ORDER_STATUS.STATUS_SIGNED) {
      pager = { ...this.state.paginationThird };
    } else if (this.state.status === ORDER_STATUS.STATUS_FINISHED) {
      pager = { ...this.state.paginationFourth };
    } else {
      pager = { ...this.state.paginationFifth };
    }

    return pager;
  }

  private setCurrentPage(pager: PaginationProps, extra?: Partial<IOrderListPageState>) {
    if (this.state.status === ORDER_STATUS.STATUS_PAID) {
      const s: any = { ...extra, paginationFirst: pager };
      this.setState(s);
    } else if (this.state.status === ORDER_STATUS.STATUS_SENT) {
      const s: any = { ...extra, paginationSecond: pager };
      this.setState(s);
    } else if (this.state.status === ORDER_STATUS.STATUS_SIGNED) {
      const s: any = { ...extra, paginationThird: pager };
      this.setState(s);
    } else if (this.state.status === ORDER_STATUS.STATUS_FINISHED) {
      const s: any = { ...extra, paginationFourth: pager };
      this.setState(s);
    } else {
      const s: any = { ...extra, paginationFifth: pager };
      this.setState(s);
    }
  }
}

export default OrderListPage;



// WEBPACK FOOTER //
// ./src/components/views/Order/OrderListPage.tsx